<template>
  <div id="bafore_checksum">
    <div v-if="successfully_unsubscribe === false">
      <div id="url_expired">
            <h4>Welcome to Doodhvale, Please wait...</h4>
      </div>
      <div id="unsub">
        You have successfully Unsubscribed.
      </div>
      <div id="unsettled">
        You have Rs. {{subscriptionObj.pendingAmount}} pending and {{subscriptionObj.emptyBottles}} pending empty bottles.<a v-bind:href="subscriptionObj.paymentUrl">Click to pay</a> 
      </div>
      <div id="url_valid">
        <div style="text-align: center;">
          <div><h4>Welcome {{userDetails.first_name}}<br>({{userDetails.mobile}})</h4></div>
          <div>
          {{userDetails.address}}</div>
          *****<br>
          <div id="unsubscribe">
            <h4>{{apiDataObj.msg}}</h4>
          </div>
          <div id="not_unsubscribe">
            <ul id="example-1">
              <li v-for="item in items">
                {{ item }}
              </li>
            </ul><br>
            Choose your feedback before Unsubscribe<br><br>
            <select style="width: 70%;" v-model="selected">
              <option v-for="option in apiDataObj.reasonList" v-bind:value="option.reason_id">
                {{ option.value }}
              </option>
            </select>
            <br><br>
            <div style="display: inline-block;">
              <form>
                <input class="button1" value="Unsubscribe" type="button" v-on:click="unsubscribe();">
              </form>
            </div>
          </div>
          <!-- <div id="unsub">
            You have successfully Unsubscribed.<br>
          </div> -->
          <!-- <div id="unsettled">
            You have Rs. {{subscriptionObj.pendingAmount}} pending and {{subscriptionObj.emptyBottles}} pending empty bottles.<a v-bind:href="subscriptionObj.paymentUrl">Click to pay</a><br>
          </div> -->
          <div id="unsettled_noempty">
            You have Rs. {{subscriptionObj.pendingAmount}} pending.<a v-bind:href="subscriptionObj.paymentUrl">Click to pay</a><br><br>
          </div>
        </div>
      </div>
    </div>
    <div v-if="successfully_unsubscribe">
      <div style="text-align: center;">
        <div><h4>Welcome {{userDetails.first_name}}<br>({{userDetails.mobile}})</h4></div>
        <div>
        {{userDetails.address}}</div>
        *****<br>
        <div id="unsub">
          You have successfully Unsubscribed.
        </div>
        <div v-if="unsettled">
          You have Rs. {{subscriptionObj.pendingAmount}} pending and {{subscriptionObj.emptyBottles}} pending empty bottles.<a v-bind:href="subscriptionObj.paymentUrl">Click to pay</a> 
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import LTable from 'src/components/UIComponents/Table.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
  import axios from 'axios'
  export default {
    components: {
      Checkbox,
      Card,
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        selected: 1,
        urlInterface: [],
        apiDataObj: [],
        userDetails: [],
        subscriptionObj: [],
        successfully_unsubscribe: false,
        unsettled: true,
        items: null
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        const params = new URLSearchParams()
        var fullUrl = document.URL
        var splitUrl = fullUrl.split('u?')
        params.append('url_str', splitUrl[1])
        axios({
          url: process.env.BASE_API + '/accounts/fetch-url-interface-data',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.urlInterface = {}
          if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
            this.urlInterface.error_msg = response.data.msg
            document.getElementById('url_valid').style.display = 'none'
          } else {
            document.getElementById('url_expired').style.display = 'none'
            this.urlInterface.action_name = response.data.action_name
            this.urlInterface.url_interface_id = response.data.url_interface_id
            this.invokeUrlAction()
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      invokeUrlAction () {
        const params = new URLSearchParams()
        params.append('url_interface_id', this.urlInterface.url_interface_id)
        params.append('action_name', this.urlInterface.action_name)
        axios({
          url: process.env.BASE_API + '/accounts/invoke-url-action',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.apiDataObj = {}
          switch (this.urlInterface.action_name) {
            case 'unsubscribe_product':
              this.apiDataObj.userId = response.data.action_response.user_id
              this.apiDataObj.subscriptionIdArr = response.data.action_response.subscription_id_arr
              this.items = response.data.action_response.prod_name_arr
              if (response.data.action_response.status === '000001') {
                document.getElementById('not_unsubscribe').style.display = 'none'
                document.getElementById('unsub').style.display = 'none'
                document.getElementById('unsettled').style.display = 'none'
                document.getElementById('unsettled_noempty').style.display = 'none'
                document.getElementById('unsubscribe').style.display = 'block'
                this.apiDataObj.msg = response.data.action_response.msg
              } else {
                document.getElementById('unsubscribe').style.display = 'none'
                document.getElementById('unsub').style.display = 'none'
                document.getElementById('unsettled').style.display = 'none'
                document.getElementById('unsettled_noempty').style.display = 'none'
                document.getElementById('not_unsubscribe').style.display = 'block'
                this.apiDataObj.reasonList = response.data.action_response.reason_list
                this.apiDataObj.productId = response.data.action_response.product_id
                this.apiDataObj.msg = response.data.action_response.msg
              }
              this.userInfo()
              break
            default:
              break
          }
          console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      userInfo () {
        const params = new URLSearchParams()
        var userId = this.apiDataObj.userId
        params.append('user_id', userId)
        axios({
          url: process.env.BASE_API + '/users/user-info',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.userDetails = {}
          this.userDetails.userId = userId
          this.userDetails.first_name = response.data.user_record.user_details.first_name
          this.userDetails.mobile = response.data.user_record.user.username
          this.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      unsubscribe () {
        // alert(this.selected)
        const params = new URLSearchParams()
        params.append('subscription_id', this.apiDataObj.subscriptionIdArr)
        axios({
          url: process.env.BASE_API + '/subscriptions/unsubscribe',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.subscriptionObj = {}
          if (response.data.status === '000000') {
            console.log(response)
            this.successfully_unsubscribe = true
            if (response.data.pending_amount > 0) {
              document.getElementById('unsub').style.display = 'none'
              document.getElementById('unsubscribe').style.display = 'none'
              document.getElementById('not_unsubscribe').style.display = 'none'
              if (response.data.pending_empty_bottle <= 0) {
                document.getElementById('unsettled').style.display = 'none'
                document.getElementById('unsettled_noempty').style.display = 'block'
              } else {
                document.getElementById('unsettled').style.display = 'block'
                document.getElementById('unsettled_noempty').style.display = 'none'
              }
              this.subscriptionObj.pendingAmount = response.data.pending_amount
              this.subscriptionObj.emptyBottles = response.data.pending_empty_bottle
              this.subscriptionObj.paymentUrl = response.data.payment_url
            } else {
              document.getElementById('unsubscribe').style.display = 'none'
              document.getElementById('not_unsubscribe').style.display = 'none'
              // document.getElementById('unsettled').style.display = 'none'
              this.unsettled = false
              document.getElementById('unsettled_noempty').style.display = 'none'
              document.getElementById('unsub').style.display = 'block'
            }
            this.submitFeedback()
          } else {
            alert(response.data.msg)
          }
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      submitFeedback () {
        const params = new URLSearchParams()
        params.append('user_id', this.apiDataObj.userId)
        params.append('product_id', this.apiDataObj.productId)
        params.append('sub_id', this.apiDataObj.subscriptionId)
        params.append('feedback', this.selected)
        axios({
          url: process.env.BASE_API + '/subscriptions/submit-feedback',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          // this.successfully_unsubscribe = true
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      }
    }
  }
</script>
<style>
.button1 {background-color: #3CB6C3; padding: 2% 20% 2% 26%; margin-bottom: 40%;}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/U.vue